<template>
    <div class="neopark-dis-main">
        <div class="container">
            <div class="section-title"><h2 v-html="salesCard.neopark_land_prev.title"></h2></div>
            <div class="section-title-desc"><p v-html="salesCard.neopark_land_prev.desc"></p></div>
            <div class="section-title-logo"><img :src="salesCard.neopark_land_prev.logo" alt=""></div>
            <div class="images-desc-mobile" v-if="isMobileChecker"><p v-html="salesCard.neopark_land_prev.images_desc"></p></div>
            <div class="dis-main-images-container">
                <div class="images-desc" v-if="!isMobileChecker"><p v-html="salesCard.neopark_land_prev.images_desc"></p></div>
                <div class="images"><div class="item-img" v-for="item in salesCard.neopark_land_prev.images"><img :src="item.img" alt=""></div></div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'neopark-dis-main',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/neopark/dis-main.scss';
    @import '@/styles/components/sales/sales-land-partials/neopark/respond/dis-main-respond.scss';
    // @import '@/styles/components/sales/respond/land-about-respond.scss';
</style>